export default __webpack_public_path__ + "static/media/ossscreen4.ff62801c.png";